










































import { buildGeekFullName, nameof, groupBy } from '@/utils';
import { GeekItemWithJobTitle } from '@/models';
import { GrantRule, grantRuleMap } from '@/models/rules';
import Vue from 'vue';

export default Vue.extend({
  name: 'GrantingItem',
  props: {
    gratification: Object as () => any,
  },
  methods: {
    titles(grantedBy: GeekItemWithJobTitle[]) {
      const groupedByKeyAsProperty = groupBy(grantedBy, nameof<GeekItemWithJobTitle>('jobTitle'));
      return Object.keys(groupedByKeyAsProperty)
        .map((key) => ({ jobTitle: key, admins: groupedByKeyAsProperty[key] }));
    },
    getGrantRule(activityType: string): string {
      return (grantRuleMap as { [key: string]: GrantRule })[activityType];
    },
    getGrantedByGeeks(grantedByList: GeekItemWithJobTitle[]): string {
      return grantedByList.map(g => buildGeekFullName(g)).join(', ');
    },
  },
});
